<template>
  <div class="agreement-page" id="agreementPageId">
    <div class="title">法律条款与平台规则</div>
    <div class="item" v-for="(item, i) in list" :key="i">
      <div class="item-title">{{ item.title }}</div>
      <div class="item-ctx">
        <div
          class="item-ctx__col"
          v-for="(agreement, agreementIndex) in item.agreementList"
          :key="agreementIndex"
        >
          <div v-if="agreement.sub && agreement.sub.length" class="item-ctx__col-wrap">
            <div class="item-ctx__col-txt">
              {{ agreement.title }}
              <div class="item-ctx__col-txt-border"></div>
            </div>
            <div class="item-ctx__col-sub">
              <div
                class="item-ctx__col-sub-row"
                v-for="(sub, subIndex) in agreement.sub"
                :key="subIndex"
                @click="jump(sub.link)"
              >
                {{ sub.title }}
              </div>
            </div>
          </div>
          <div v-else class="item-ctx__col-wrap" @click="jump(agreement.link)">
            <div class="item-ctx__col-txt">
              {{ agreement.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="item">
      <div class="item-title">联系我们</div>
      <div class="item-contact">
        <div>如果您对本政策以及我们处理您的个人信息的行为有任何疑问、意见或建议，可通过以下方式与我们联系：</div>
        <div>1. 将问题发送至邮箱isc@xiaolachuxing.com</div>
        <div>2. APP内选择“我的”→“客服中心”，提交问题</div>
        <div>3. 拨打客服电话：10102828</div>
      </div>
    </div>
  </div>
</template>

<script>
import { CoupeSDK } from '@xl/coupe-sdk'
const environment =
  process.env.NODE_ENV === 'development'
    ? 'stg'
    : document.documentElement.dataset.vanEnv || 'prd'
// 实例化 sdk
const sdk = new CoupeSDK({
  coupeId: '1c67ca6f1fcb48b88840b1404cd43ec8',
  env: environment
})

export default {
  data() {
    return {
      list: []
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      // 调用 fetch 获取数据
      const data = await sdk.fetch().catch(() => {
        this.getDefaultData()
      }) || {}
      const { list } = data
      if (!list) {
        this.getDefaultData()
        return
      }
      try {
        this.list = JSON.parse(list)
      } catch (error) {
        this.getDefaultData()
      }
    },
    getDefaultData() {
      this.list = [
        {
          title: '法律条款',
          agreementList: [
            {
              title: '网约车用户服务协议',
              link: 'https://user-h5.xiaolachuxing.com/index/agreement/software'
            },
            {
              title: '网约车司机合作协议',
              link: 'https://driver-h5.xiaolachuxing.com/index/agreement/software'
            },
            {
              title: '小拉平台准入承诺',
              link: 'https://driver-h5.xiaolachuxing.com/index/agreement/promise'
            }
          ]
        },
        {
          title: '隐私政策',
          agreementList: [
            {
              title: '隐私政策概览',
              link: '',
              sub: [
                {
                  title: '用户隐私政策摘要',
                  link: 'https://user-h5.xiaolachuxing.com/index/agreement/privacy-abstract'
                },
                {
                  title: '用户隐私政策',
                  link: 'https://user-h5.xiaolachuxing.com/index/agreement/privacy'
                },
                {
                  title: '司机隐私政策',
                  link: 'https://driver-h5.xiaolachuxing.com/index/agreement/privacy'
                }
              ]
            },
            {
              title: '个人信息收集清单',
              link: '',
              sub: [
                {
                  title: '小拉出行-IOS',
                  link: 'https://user-h5.xiaolachuxing.com/index/agreement/person-info'
                },
                {
                  title: '小拉出行-安卓',
                  link: 'https://user-h5.xiaolachuxing.com/index/agreement/person-info'
                },
                {
                  title: '小拉出行司机版-IOS',
                  link: 'https://driver-h5.xiaolachuxing.com/index/agreement/personal-list'
                },
                {
                  title: '小拉出行司机版-安卓',
                  link: 'https://driver-h5.xiaolachuxing.com/index/agreement/personal-list'
                }
              ]
            },
            {
              title: '第三方共享清单',
              link: '',
              sub: [
                {
                  title: '小拉出行-IOS',
                  link: 'https://user-h5.xiaolachuxing.com/index/agreement/third-list'
                },
                {
                  title: '小拉出行-安卓',
                  link: 'https://user-h5.xiaolachuxing.com/index/agreement/third-list'
                },
                {
                  title: '小拉出行司机版-IOS',
                  link: 'https://driver-h5.xiaolachuxing.com/index/agreement/third-list'
                },
                {
                  title: '小拉出行司机版-安卓',
                  link: 'https://driver-h5.xiaolachuxing.com/index/agreement/third-list'
                }
              ]
            },
            {
              title: '第三方SDK目录',
              link: '',
              sub: [
                {
                  title: '小拉出行-IOS',
                  link: 'https://user-h5.xiaolachuxing.com/index/agreement/ios-sdk'
                },
                {
                  title: '小拉出行-安卓',
                  link: 'https://user-h5.xiaolachuxing.com/index/agreement/android-sdk'
                },
                {
                  title: '小拉出行司机版-IOS',
                  link: 'https://driver-h5.xiaolachuxing.com/index/agreement/ios-sdk'
                },
                {
                  title: '小拉出行司机版-安卓',
                  link: 'https://driver-h5.xiaolachuxing.com/index/agreement/android-sdk'
                }
              ]
            },
            {
              title: '系统权限使用清单',
              link: '',
              sub: [
                {
                  title: '小拉出行-IOS',
                  link: 'https://user-h5.xiaolachuxing.com/index/agreement/permission-list'
                },
                {
                  title: '小拉出行-安卓',
                  link: 'https://user-h5.xiaolachuxing.com/index/agreement/permission-list'
                }
              ]
            }
          ]
        },
        {
          title: '平台安全规则',
          agreementList: [
            {
              title: '小拉出行平台安全规则',
              link: '',
              sub: [
                {
                  title: '小拉出行-IOS',
                  link: 'https://user-h5.xiaolachuxing.com/index/agreement/safe-rules'
                },
                {
                  title: '小拉出行-安卓',
                  link: 'https://user-h5.xiaolachuxing.com/index/agreement/safe-rules'
                }
              ]
            }
          ]
        }
      ]
    },
    jump(url) {
      if (url) {
        window.open(url)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.agreement-page {
  margin: 0 auto;
  width: 1190px;
  font-family: PingFang SC,PingFang SC-Regular;
}
.title {
  color: rgba(0,0,0,.85);
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;
  padding: 50px 0 16px 0;
}
.item {
  padding: 32px 0;
  border-bottom: 2px solid #f7f7f7;
  display: flex;
  &:nth-last-of-type(1) {
    border: none;
  }
  &-title {
    color: rgba(0,0,0,.85);
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    flex: 0 0 140px;
  }
  &-ctx {
    flex: 1 1;
    font-size: 14px;
    display: flex;
    &__col {
      width: 220px;
      color: rgba(0,0,0,.65);
      font-weight: 400;
      line-height: 24px;
      cursor: pointer;
      &-wrap {
        width: fit-content;
        &:hover {
          .item {
            max-height: 600px;
          }
          .item-ctx__col-sub {
            display: block;
            max-height: 500px;
            padding-top: 20px;
            opacity: 1;
          }
          .item-ctx__col-txt-border {
            display: block;
          }
        }
      }
      &-txt {
        display: inline-block;
        position: relative;
        &:hover {
          color: rgb(238, 109, 61);
        }
        &-border {
          width: calc(100% - 6px);
          height: 1px;
          position: absolute;
          bottom: -6px;
          transform: translateX(3px);
          background-color: rgb(238, 109, 61);
          display: none;
        }
      }
      &-sub {
        opacity: 0;
        flex-direction: column;
        padding-top: 0;
        max-height: 0;
        transition: .2s linear;
        &-row {
          width: fit-content;
          margin-top: 5px;
          &:nth-of-type(1) {
            margin-top: 0;
          }
          &:hover {
            color: rgb(238, 109, 61);
          }
        }
      }
    }
  }
  &-contact {
    div {
      color: rgba(0,0,0,.65);
      font-weight: 400;
      line-height: 24px;
      font-size: 14px;
    }
  }
}
</style>
